class AccountDialog extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('#account-dialog');
    this.dialogTrigger = this.dialog?.closest('.header__icon-group__account');
    this.dialogTrigger?.addEventListener('mouseover', this.handleDialog.bind(this));
    this.dialog?.addEventListener('mouseout', this.handleDialog.bind(this));
  }

  handleDialog(e) {
    let headerSearch = document.querySelector('.header__search details');
    if (e.type == 'mouseover' && !headerSearch?.hasAttribute('open')) {
      this.dialog.classList.add('active');
    }
    if (e.type == 'mouseout') {
      this.dialog.classList.remove('active');
    }
  }
}

customElements.define('account-dialog', AccountDialog);
